module.exports = "/src/views/player/help/images/heli1.jpg";